import { Base } from "../../../base/components/base"
import { Div } from "../../../base/components/native/div"
import { Input } from "../../../base/components/native/input"
import state from "../../../base/services/state"
import utils from "../../../utils"
import * as styles from "./upload-area.style"

export const UploadArea = () => {
	const base = Base()
	base.cssClass(styles.baseStyle)

	const icon = Div('📁')
	icon.cssClass(styles.iconStyle)
	base.append(icon)

	const text = Div('Click to select or drag & drop your file')
	text.cssClass(styles.textStyle)
	base.append(text)

	const hint = Div('CSV file type • Max 1GB')
	hint.cssClass(styles.hintStyle)
	base.append(hint)

	const file = Input('', 'file')
	file.style({ display: 'none' })
	base.append(file)

	base.el.addEventListener('click', () => {
		if (!state.get('uploading')) {
			file.el.click()
		}
	})

	file.el.addEventListener('change', (e: Event) => {
		const input = e.target as HTMLInputElement | null
		if (!input?.files?.length) {
			return
		}
		// only accept CSV files
		if (input.files[0].type !== 'text/csv') {
			alert('Please upload a valid CSV file.')
			return
		}
		const selectedFile = input.files[0]
		handleSelectFile(selectedFile)
	})

	// Drag and drop
	base.el.addEventListener('dragover', (e: DragEvent) => {
		e.preventDefault()
		base.el.classList.add('dragover')
	})

	base.el.addEventListener('dragleave', (e: DragEvent) => {
		base.el.classList.remove('dragover')
	})

	base.el.addEventListener('drop', (e: DragEvent) => {
		e.preventDefault()
		base.el.classList.remove('dragover')
		const dt = e.dataTransfer
		if (!state.get('uploading') && dt && dt.files.length > 0) {
			handleSelectFile(dt.files[0])
		}
	})

	function handleSelectFile(file: File) {
		icon.style({display: 'none'})
		text.text(file.name)
		const type = file.name.split('.').pop()?.toUpperCase() || 'N/A'
		const size = utils.file.formatSize(file.size)
		hint.text(`${type} • ${size}`)
		base.emit('file-selected', file);
	}

	function reset() {
		icon.style({display: 'block'})
		text.text('Click to select or drag & drop your file')
		hint.text('CSV file type • Max 1GB')
		file.el.value = ''
	}


	return Object.assign(base, {
		reset
	})
}